<template>
  <v-icon v-if='hubConnectionEstablished' color='success'>mdi-cloud</v-icon>
  <v-icon v-else color='error'>mdi-cloud-off-outline</v-icon>
</template>

<script>
import { mapState } from 'vuex';
import { HubConnectionState } from '@microsoft/signalr';

export default {
  name: 'HubStatus',
  computed: {
    ...mapState({
      hubConnectionEstablished: (state) => state.signalR?.connectionStatus === HubConnectionState.Connected
    })
  }
}
</script>

<style scoped>

</style>
